import SendbirdChat from "@sendbird/chat"
import {
  GroupChannelModule,
  GroupChannelFilter,
  GroupChannelListOrder,
} from "@sendbird/chat/groupChannel"

const sb = SendbirdChat.init({
  appId: import.meta.env.VITE_SENDBIRD_APP_ID,
  modules: [new GroupChannelModule()],
})

export const connectToSendbird = async (
  userId: string,
  accessToken?: string
) => {
  try {
    const user = await sb.connect(userId, accessToken)
    return user
  } catch (error) {
    console.error("Sendbird connection error:", error)
    throw error
  }
}

export const disconnectFromSendbird = async () => {
  try {
    await sb.disconnect()
  } catch (error) {
    console.error("Sendbird disconnection error:", error)
  }
}

export const getGroupChannelList = async () => {
  const groupChannelFilter = new GroupChannelFilter()
  groupChannelFilter.includeEmpty = true

  const collection = sb.groupChannel.createGroupChannelCollection({
    filter: groupChannelFilter,
    order: GroupChannelListOrder.LATEST_LAST_MESSAGE,
  })

  let channels = await collection.loadMore()

  while (collection.hasMore) {
    const moreChannels = await collection.loadMore()
    channels = channels.concat(moreChannels)
  }

  return channels
}

export const getGroupChannel = async (channelUrl: string) => {
  return await sb.groupChannel.getChannel(channelUrl)
}

export default sb
